export default __webpack_public_path__ + "static/media/light-above.6133d87b.gif";